export default "__VITE_ASSET__BZuAOSA0__"